import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChartHistorical } from "../components/ComponentChartHistorical";
import { ComponentChartForecast } from "../components/ComponentChartForecast";
import { SlideContext } from "../Context";
import { REPORT_ID } from '../constants';

export const slide31ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_ID === identification.reportId) {
    if (identification.componentId === "chart-historical") {
      input.component = <ComponentChartHistorical context={componentContext as SlideContext}></ComponentChartHistorical>;
    }
    if (identification.componentId === "chart-forecast") {
      input.component = <ComponentChartForecast context={componentContext as SlideContext}></ComponentChartForecast>;
    }

  }
  return next(input);
};
